<template>
  <div class="text-ontick-carbon-900 h-full w-full dark:text-gray-300">
    <template v-if="alteredURL">
      <div class="flex h-full w-full items-center justify-center space-x-6 pt-12">
        <span v-html="filter" class="scale-75 transform"></span>
        <div>
          <p class="text-2xl font-bold">Extensão não encontrada</p>
        </div>
      </div>
    </template>
    <template v-else>
      <div v-if="isLoading" class="flex h-full w-full items-center justify-center">
        <div class="animate-spin">
          <i v-html="$icons.spinner_lg" class="text-ontick-blue-600"></i>
          <span class="sr-only"> Carregando </span>
        </div>
      </div>
      <div class="relative space-y-24 pb-12" v-else>
        <header-component
          :data="data.partner_info"
          @subscribe="subscribe(data.valid_license_found, data.active_for_user, data.extension_id)"
        />
        <!-- <div
          class="dark:bg-ontick-carbon-500 sticky top-0 z-50 !my-0 flex w-full items-center justify-center bg-gray-50 py-4 sm:hidden"
        >
          <ontick-button color="secondary" @click.native="$emit('subscribe')">
            <span class="font-bold uppercase"> Assinar extensão </span>
          </ontick-button>
        </div> -->
        <div class="space-y-24 pt-12">
          <hero-2-component v-if="partner.hero.type === 2" :data="partner.hero" :partnerInfo="data.partner_info" />
          <hero-component v-else :data="partner.hero" :partnerInfo="data.partner_info" class="pl-6" />
          <strategies-component :data="data.strategies" :header="partner.strategies" @details="activeDetails" />
          <table-robstrader-component v-if="partner.tableRobsTrader" />
          <cta-2-component :data="partner.cta" />
          <about-component :data="partner.about" />
          <stats-component class="px-6" :data="partner.stats" v-if="partner.stats" />
          <picture-component v-if="partner.picture" :data="partner.picture" />
          <features-2-component class="px-6" :data="partner.features" v-if="partner.features.type === 2" />
          <features-component class="px-6" :data="partner.features" v-else />
          <testimonials-component :data="partner.testimonials" v-if="partner.testimonials" />
          <plans-component
            :header="partner.plans"
            :plans="data.plans"
            @subscribe="subscribe($event.valid_license_found, $event.active_for_user, $event.extension_id)"
          />
          <!-- <cta-2-component :data="partner.cta" /> -->

          <!-- <price-component
            v-if="partner.pricing"
            :data="partner.pricing"
            :price="data.extension_price"
            :active_for_user="data.active_for_user"
            @subscribe="
              data.valid_license_found;
              subscribe(
                data.valid_license_found,
                data.active_for_user,
                data.extension_id
              );
            "
          /> -->
          <!-- <cta-component
            :data="partner.cta"
            :price="data.extension_price"
            class="mx-6"
            v-if="!data.active_for_user"
            @subscribe="
              data.valid_license_found;
              subscribe(
                data.valid_license_found,
                data.active_for_user,
                data.extension_id
              );
            "
          /> -->
        </div>
      </div>
    </template>
    <ontick-aero :active="active_details" @close="(active_details = false), (details.index = null)">
      <product-component
        v-if="active_details"
        :active="active_details"
        :strategy_id="details.strategy"
        :product_id="details.product"
        :pagination="details.index"
        @close="(active_details = false), (details.index = null)"
        disableAdd
        disablePagination
      />
    </ontick-aero>
  </div>
</template>

<script>
import FeaturesComponent from "../../components/extension-details/features.component.vue";
import headerComponent from "../../components/extension-details/header.component.vue";
import HeroComponent from "../../components/extension-details/hero.component.vue";
import StatsComponent from "../../components/extension-details/stats.component.vue";
import { mapActions, mapGetters } from "vuex";
import { filter } from "../../../../assets/icons/isometric";
import content from "../../content";
import StrategiesComponent from "../../components/extension-details/strategies.component.vue";
import Cta2Component from "../../components/extension-details/cta2.component.vue";
import AboutComponent from "../../components/extension-details/about.component.vue";
import PlansComponent from "../../components/extension-details/plans.component.vue";
import ProductComponent from "../../../marketplace/pages/details/product.component.vue";
import TestimonialsComponent from "../../components/extension-details/testimonials.component.vue";
import Features2Component from "../../components/extension-details/features2.component.vue";
import Hero2Component from "../../components/extension-details/hero2.component.vue";
import PictureComponent from "../../components/extension-details/picture.component.vue";
import TableRobstraderComponent from "../../components/extension-details/table-robstrader.component.vue";
export default {
  components: {
    headerComponent,
    HeroComponent,
    StatsComponent,
    FeaturesComponent,
    StrategiesComponent,
    Cta2Component,
    AboutComponent,
    PlansComponent,
    ProductComponent,
    TestimonialsComponent,
    Features2Component,
    Hero2Component,
    PictureComponent,
    TableRobstraderComponent,
  },

  data() {
    return {
      data: {},
      isLoading: true,
      alteredURL: false,
      active_details: false,
      details: null,
      filter,
    };
  },

  computed: {
    ...mapGetters({ getSelectedAccount: "accountTypes/getSelectedAccount" }),
    partner() {
      const partner = this.formatted_owner.toLowerCase();
      if (partner === "8remora") {
        return content["_8remora"]["_8REMO_EXT_1"];
      }
      if (partner === "3pinvesting") {
        return content["_3pinvesting"]["_3PINVES_EXT_1"];
      }
      if (partner === "5hundredboot") {
        return content["_5hundred"]["_5HUNDRED_EXT_1"];
      }
      return content[partner]?.[this.$route.params.extension_group]
        ? content[partner][this.$route.params.extension_group]
        : content.placeholder;
    },
    formatted_owner() {
      return this.data?.partner_info?.extension_owner
        ? this.data.partner_info.extension_owner
            .toLowerCase()
            .replaceAll("_", "")
            .replaceAll(" ", "")
            .replaceAll(".", "")
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
        : "";
    },
    accountId() {
      return this.getSelectedAccount.account_id;
    },
  },

  methods: {
    ...mapActions({
      setUserConfig: "config/setUserConfig",
      fetchAccounts: "accountTypes/fetchAccounts",
    }),
    activeDetails(detail) {
      this.details = { ...detail };
      this.active_details = true;
    },
    getConfig() {
      return new Promise((resolve, reject) => {
        this.$api
          .get(this.$endpoint.USER_CONFIGS)
          .then((response) => {
            this.setUserConfig(response.data);
            this.fetchAccounts(response.data.accounts);
            resolve();
          })
          .catch((error) => {
            console.error(error);
            if (error.data.status == "error") {
              this.setUserConfig(error.data);
            }
            reject();
          });
      });
    },
    getData() {
      if (!this.accountId) {
        setTimeout(this.getData, 100);
      } else {
        this.$api
          .get(`${this.$endpoint.GET_EXTENSION_DETAILS}/${this.$route.params.extension_group}`, {
            params: {
              account_id: this.accountId,
            },
          })
          .then((res) => {
            this.data = res.data;
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    activateExtension(id) {
      this.$api
        .post(this.$endpoint.CHECK_INVOICE, {
          invoice_type: "EXTENSION",
          extension_id: id,
        })
        .then((res) => {
          switch (res.data.action) {
            case "INVOICE_SCREEN":
              this.$router.push({
                name: "Pagamentos",
                query: {
                  type: "extensions",
                  extension_id: id,
                },
              });
              break;
            case "SUCCESS_SCREEN":
              this.$swal({
                title: "Sucesso",
                text: "Extensão adquirida com sucesso",
                icon: "success",
                iconHtml: this.$icons.swal_success,
                timer: 3000,
                timerProgressBar: true,
              });
              this.getConfig();
              this.getData();
              break;
            case "ADDRESS_SCREEN":
              this.$router.push({
                name: "Pagamentos",
                query: {
                  type: "extensions",
                  extension_id: id,
                },
              });
              break;
            default:
              this.$router.push({
                name: "Pagamentos",
                query: {
                  type: "extensions",
                  extension_id: id,
                },
              });
              break;
          }
        })
        .catch((err) => {
          console.error(err);
          if (err.data.action === "ADDRESS_SCREEN") {
            this.$router.push({
              name: "Pagamentos",
              query: {
                type: "extensions",
                extension_id: id,
              },
            });
          } else {
            this.$swal("Erro", this.$filters.capitalize(err.data.msg), "error");
          }
        });
    },
    disableExtension(id) {
      this.$api
        .post(this.$endpoint.DISABLE_EXTENSION, {
          extension_id: id,
        })
        .then((res) => {
          this.$swal({
            title: "Sucesso",
            text: res.data.msg,
            icon: "success",
            iconHtml: this.$icons.swal_success,
          });
        })
        .catch((err) => {
          console.error(err);
          this.$swal("Erro", err.data.msg.charAt(0).toUpperCase() + err.data.msg.slice(1), "error");
        })
        .finally(() => {
          this.getData();
          this.getConfig();
        });
    },
    reactivate(id) {
      this.$api
        .post(this.$endpoint.REACTIVATE_EXTENSION, {
          extension_id: id,
        })
        .then((res) => {
          this.$swal({
            title: "Sucesso",
            text: res.data.msg,
            icon: "success",
            iconHtml: this.$icons.swal_success,
          });
        })
        .catch((err) => {
          if (err.data.modal_action) {
            this.upgradeModalData = {
              type: err.data.modal_action,
              name: this.data.extension_name,
              active: true,
            };
          } else {
            this.$swal("Erro", err.data.msg, "error");
          }
        })
        .finally(() => {
          this.getData();
          this.getConfig();
        });
    },
    subscribe(licenseFound, isActive, id) {
      if (isActive && !licenseFound) {
        this.disableExtension(id);
      } else if (!isActive && !licenseFound) {
        this.activateExtension(id);
      } else if (!isActive && licenseFound) {
        this.reactivate(id);
      } else {
        this.disableExtension(id);
      }
    },
  },

  // watch: {
  //   accountId: {
  //     immediate: true,
  //     handler() {
  //       this.getData();
  //     },
  //   },
  // },

  created() {
    this.getData();
    sessionStorage.isNavigating = true;
  },

  unmounted() {},
};
</script>

<style></style>
